import { Navigate } from "react-router-dom";
import AdminPage from "../admin";

function PrivateRoute({ component: component, setSidebarActive, sidebarActive, profileData }) {
    const token = window.localStorage.getItem('token')
    return token ? <AdminPage profileData={profileData} setSidebarActive={setSidebarActive} sidebarActive={sidebarActive} /> : <Navigate to='/login' />
}
export default PrivateRoute;